export var handleOrder3dMap = function (history) {
    history.push({
        pathname: "/order3dmaps",
        search: window.location.search,
    });
};
